// Loader lazy di Mermaid (chunk dedicato ~1.5MB: mai nel bundle principale).
// `securityLevel: 'strict'` = niente script/click handler nei diagrammi.

import type { Mermaid } from 'mermaid';

let mermaidPromise: Promise<Mermaid> | null = null;
let testOverride: Mermaid | null = null;

/** Solo per i test: inietta un renderer fake senza dynamic import. */
export function __setMermaidForTests(instance: Mermaid | null): void {
  testOverride = instance;
  mermaidPromise = null;
}

export async function loadMermaid(): Promise<Mermaid> {
  if (testOverride) return testOverride;
  if (!mermaidPromise) {
    mermaidPromise = import('mermaid').then(m => {
      const mermaid = m.default;
      mermaid.initialize({
        startOnLoad: false,
        securityLevel: 'strict',
        theme: 'neutral',
        fontFamily: 'ui-sans-serif, system-ui, sans-serif',
      });
      return mermaid;
    });
  }
  return mermaidPromise;
}
